function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-764.000000, -3734.000000)",
  stroke: "#183E6B",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(120.000000, 245.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 3469.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(645.142136, 20.000000)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 15.3578644,
  y1: 0,
  x2: 15.3578644,
  y2: 57
}), /*#__PURE__*/React.createElement("polyline", {
  strokeLinecap: "square",
  transform: "translate(15.000000, 42.426407) rotate(-225.000000) translate(-15.000000, -42.426407) ",
  points: "5 32.4264069 25 32.4264069 25 52.4264069"
}))))));
var SvgIconArrowLarge = function SvgIconArrowLarge(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "58px",
    viewBox: "0 0 32 58",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconArrowLarge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-arrow-large.a4098ab2.svg";
export { ForwardRef as ReactComponent };